import { Link } from 'react-router-dom';
import './header.css';
import logo from "../../assets/abjoy-logo.png";

const Header = () => {
  return (
    <header className="navbar">
      <div className="navbar-logo">
        <Link to="/">
          <img src={logo} alt="Brand Logo" className="logo-img" />
        </Link>
      </div>
      
      <nav className="navbar-links">
        <Link to="/">Home</Link>
        <Link to="/construction">Construction</Link>
        <Link to="/sound-hire">Sound Hire</Link>
        <Link to="/software-development">Software Development</Link>
        <Link to="/contact-us" className="nav-cta">Contact Us</Link>
      </nav>
    </header>
  )
}

export default Header